import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { GUIActions } from '../../../types/game-types';
import { useCurrencyStore } from '../../zustand/useCurrencyStore';
import { unitStats } from '../../../stats';
import { inspirationReducer } from './inspiration.reducer';
import { EventsManager } from '@game-libs/events-manager';
import { roundTo } from '@game-libs/exc-libs';
import { CONFIG } from '../../../config';
import { GameplayEvents } from '../../../types/game-events';
import { useDragonHealthStore } from '../../zustand/useDragonHealthStore';

export const wizardReducer = (scratch: StatsSnapshot) => {
  // const wizard = scratch.generators.wizard;
  const stats = unitStats.wizard;
  const { emit } = EventsManager();

  const isCritical = Math.random() * 100 < (stats.criticalChance ?? 0);
  const damage = (stats.damagePerTick ?? 0) + (isCritical ? (stats.criticalDamage ?? 0) : 0);

  if (isCritical) {
    const lightningDamage = stats.criticalDamage ?? 0;
    const lightningGold = lightningDamage * CONFIG.game.goldPerDamage;

    emit(GameplayEvents.LIGHTNING_DAMAGE_DRAGON, {
      damage: lightningDamage,
      gold: lightningGold,
    });
  }

  const nextHealth = Math.max(0, useDragonHealthStore.getState().dragonHealth - damage);
  useDragonHealthStore.getState().setHealth(nextHealth);
  const goldGain =
    (isCritical ? (stats.criticalDamage ?? 1) / (stats.damagePerTick ?? 1) : 1) * (stats.goldGeneration ?? 0);
  useCurrencyStore.getState().addGold(goldGain);

  const currencyBeforeInspiration = useCurrencyStore.getState();
  const nextInspiration = inspirationReducer(
    currencyBeforeInspiration.inspiration,
    stats.inspirationGeneration ?? 0,
    scratch.upgrades,
  );
  useCurrencyStore.getState().sync({ inspiration: nextInspiration });

  const currencyForMana = useCurrencyStore.getState();
  const previousMana = currencyForMana.mana;
  const nextMana = roundTo(Math.max(0, currencyForMana.mana - CONFIG.game.manaDrain));
  useCurrencyStore.getState().setMana(nextMana);
  if (previousMana > 0 && nextMana <= 0) {
    emit(GUIActions.NOT_ENOUGH_MANA);
  }

};
